import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel, useValue, ValueToCollection } from '@morningtrain/react-resources'
import RevenueTable from 'pages/app/economy/partials/RevenueTable'

export default function RevenueTables () {
  const isHourly = useValue('meta.hourly')

  return (
    <ValueToCollection name='table'>
      <ForEachModel>
        <UI.Card tight className='pt-6 sm:pt-10'>
          <UI.CardHeader withPadding>
            <UI.SecondaryHeading>
              <Displays.Text name='key' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='collection'>
            <RevenueTable isHourly={isHourly} />
          </ValueToCollection>
        </UI.Card>
      </ForEachModel>
    </ValueToCollection>
  )
}
